<template>
  <div class="myorder" v-loading="loading">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单中心</el-breadcrumb-item>
      <el-breadcrumb-item>头程订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容 -->
    <el-card class="main" style="margin-top: 20px">
      <!-- 头部查询 -->
      <div slot="header" class="clearfix toolbar">
        <div class="search-panel">
          <div class="search-panel__main">
            <div class="search-field search-field--w200">
              <span class="search-field__label">运单号</span>
              <el-input
                placeholder="多条用逗号分隔"
                v-model="orderClientNo"
                clearable
                size="small"
                @keyup.enter.native="handleSearch"
              />
            </div>
            <div class="search-field search-field--w200">
              <span class="search-field__label">预约号</span>
              <el-input
                placeholder="多条用逗号分隔"
                v-model="shipmentIdList"
                clearable
                size="small"
                @keyup.enter.native="handleSearch"
              />
            </div>
            <div class="search-field search-field--w200">
              <span class="search-field__label">订单号/入仓编号</span>
              <el-input
                placeholder="请输入"
                v-model="orderNos"
                clearable
                size="small"
                @keyup.enter.native="handleSearch"
              />
            </div>
            <div class="search-field search-field--w140">
              <span class="search-field__label">品名</span>
              <el-input
                placeholder="请输入"
                v-model="goodsName"
                clearable
                size="small"
                @keyup.enter.native="handleSearch"
              />
            </div>
            <div class="search-panel__actions">
              <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
              <el-button
                type="text"
                size="small"
                class="search-panel__toggle"
                @click="searchExpanded = !searchExpanded"
              >
                {{ searchExpanded ? '收起' : '更多' }}
                <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </el-button>
            </div>
          </div>
          <transition name="search-expand">
            <div v-show="searchExpanded" class="search-panel__extra">
              <div class="search-field search-field--w140">
                <span class="search-field__label">支付状态</span>
                <el-select
                  clearable
                  v-model="paymentStatus"
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="item in statusData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <div class="search-field search-field--date">
                <span class="search-field__label">下单时间</span>
                <el-date-picker
                  v-model="createTime"
                  type="datetimerange"
                  align="right"
                  size="small"
                  start-placeholder="开始"
                  end-placeholder="结束"
                  :default-time="['00:00:00', '23:59:59']"
                />
              </div>
              <div class="search-field search-field--w140">
                <span class="search-field__label">国家</span>
                <country :countrys="country" @getCty="getCountry" />
              </div>
            </div>
          </transition>
        </div>
        <!-- 第二行：功能区 -->
        <div class="toolbar-line toolbar-line--actions">
          <el-button type="primary" size="small" @click="copyOrder">复制下单</el-button>
          <el-button type="primary" size="small" @click="submitDialog">提交付款</el-button>
          <el-button type="success" size="small" icon="el-icon-download" @click="getMaitou">下载唛头</el-button>
          <el-button type="success" size="small" icon="el-icon-download" @click="getRucangdan">入仓单</el-button>
          <el-button size="small" @click="quxiaodingdan">取消订单</el-button>
          <el-select
            v-model="fileVal"
            clearable
            placeholder="文件类型"
            size="small"
            class="action-file-type"
          >
            <el-option
              v-for="item in fileType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-upload
            class="upload-inline"
            :action="uploadAction"
            :headers="uploadHeaders"
            :data="{ fileType: fileVal }"
            name="upload"
            :on-success="setFile"
            :before-upload="beforeOrderFileUpload"
            :show-file-list="false"
            :disabled="!fileVal"
          >
            <el-button size="small" type="primary" :disabled="!fileVal">
              上传附件
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
          <el-checkbox v-model="showExtraColumns" size="small" class="extra-cols-toggle">次要列</el-checkbox>
        </div>
      </div>
      <!-- 状态 -->
       <div class="table_tag">
        <el-row >
          <el-col :span="2"
            ><div
              class="grid-content bg-purple"
              :class="{ current: num == 1 }"
              v-on:click="change(1)"
            >
              全部【{{ quanbu }}】
            </div></el-col
          >
          <el-col :span="2" 
            ><div
              class="grid-content bg-purple"
              :class="{ current: num == 3 }"
              v-on:click="change(3)"            
            >
              待入库【{{ dairuku }}】
            </div></el-col
          >
          <el-col :span="2"
            ><div
              class="grid-content bg-purple"
              :class="{ current: num == 4 }"
              v-on:click="change(4)"
            >
              已入仓【{{ yirucang }}】
            </div></el-col
          >
          <el-col :span="2"
            ><div
              class="grid-content bg-purple"
              :class="{ current: num == 5 }"
              v-on:click="change(5)"
            >
              已开船【{{ yikaichuan }}】
            </div></el-col
          >
          <el-col :span="2"
            ><div
              class="grid-content bg-purple"
              :class="{ current: num == 6 }"
              v-on:click="change(6)"
            >
              已到港【{{ yidaogang }}】
            </div></el-col
          >
          <el-col :span="2"
            ><div
              class="grid-content bg-purple"
              :class="{ current: num == 7 }"
              v-on:click="change(7)"
            >
              已提柜【{{ yitigui }}】
            </div></el-col
          >
          <el-col :span="2"
            ><div
              class="grid-content bg-purple"
              :class="{ current: num == 8 }"
              v-on:click="change(8)"
            >
              已派送【{{ yipaisong }}】
            </div></el-col
          >
          <el-col :span="2"
            ><div
              class="grid-content bg-purple"
              :class="{ current: num == 9 }"
              v-on:click="change(9)"
            >
              已取消【{{ yiquxiao }}】
            </div></el-col
          >
        </el-row>
      </div>
      <!-- 信息列表：border 支持拖拽调列宽；min-width 列吸收剩余宽度铺满版块 -->
      <div class="table-wrap">
      <el-table
        :data="orderData"
        class="myorder-table"
        style="width: 100%"
        border
        :stripe="true"
        ref="multipleTable"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
      >
        <el-table-column type="selection" width="48" fixed="left"></el-table-column>
        <el-table-column label="操作" width="72" fixed="left">
          <template slot-scope="scope">
            <el-link
              v-if="scope.row.unpaid !== 0"
              type="primary"
              :underline="false"
              icon="el-icon-download"
              @click.stop="getBill(scope.row.orderNo)"
              >费用</el-link
            >
            <el-link
              v-if="scope.row.orderLogStatus == '已下单'"
              type="primary"
              :underline="false"
              icon="el-icon-edit"
              @click.stop="updadate(scope.row.orderNo)"
              >修改</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="运单号" min-width="132" fixed="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click.stop="toOrderdeta(scope.row.orderNo)"
              >{{ scope.row.clientNo }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="物流状态" prop="orderLogStatus" width="100" fixed="left">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click.stop="openDrawer(scope.$index, scope.row)"
            >{{ scope.row.orderLogStatus }}</el-link>
            <div class="cell-sub">{{ scope.row.orderLogStatusTime | dateformat1 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="下单" width="96">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单/入仓" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.whNo != null && scope.row.whNo !== "" ? scope.row.whNo : scope.row.orderNo }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="showExtraColumns"
          label="品名"
          prop="goodsName"
          min-width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="目的地" prop="shipment" min-width="110" show-overflow-tooltip></el-table-column>
        <el-table-column label="渠道" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="channel-cell">
              <span class="channel-cell__name">{{ scope.row.channelName }}</span>
              <el-tag
                v-if="scope.row.clearanceModeTxt || scope.row.clearanceMode === '0' || scope.row.clearanceMode === '1'"
                size="mini"
                :type="String(scope.row.clearanceMode) === '1' ? 'warning' : 'info'"
                effect="plain"
                class="clearance-tag"
              >{{ scope.row.clearanceModeTxt || (String(scope.row.clearanceMode) === '1' ? '单票单清' : '合单清') }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="报关" width="86">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.declareTypeTxt"
              size="mini"
              :type="declareTagType(scope.row)"
              effect="plain"
            >{{ scope.row.declareTypeTxt }}</el-tag>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column label="件重体 / 计费" min-width="148">
          <template slot-scope="scope">
            <div>{{ scope.row.pvwText }}</div>
            <div class="cell-sub">计费 {{ scope.row.settleText }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showExtraColumns"
          label="转单号"
          prop="enLogno"
          min-width="130"
        >
          <template slot-scope="scope">
            <div
              v-for="(item, index) in scope.row.enLogno"
              :key="index"
            >
              <el-link
                type="info"
                :underline="false"
                @click.stop="openDrawerTrack(scope.$index, item)"
              >{{ item }}</el-link>
            </div>
            <span v-if="scope.row.trackStatus != ''">【{{ scope.row.trackStatus }}】</span>
          </template>
        </el-table-column>
        <el-table-column label="付款" width="72">
          <template slot-scope="scope">
            <span v-if="scope.row.recStatus == '0'" style="color: #f56c6c">{{
              scope.row.recStatusText
            }}</span>
            <span v-else>{{ scope.row.recStatusText }}</span>
          </template>
        </el-table-column>
        <el-table-column label="应付(元)" prop="unpaid" width="88" align="right">
          <template slot-scope="scope">
            <span v-if="scope.row.unpaid != '0'" style="color: #f56c6c">{{
              scope.row.unpaid
            }}</span>
            <span v-else>{{ scope.row.unpaid }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <span class="empty-tip">暂无订单数据</span>
        </template>
      </el-table>
      </div>
      <!-- 分页功能 -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

      <el-dialog
        class="addDialog"
        title="新增收款确定"
        :before-close="closeDialog"
        :visible.sync="dialogTableVisible"
        :close-on-click-modal="false"
        width="25%"
        style="text-align:center;">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="折合币种" prop="currency">
              <el-select
                v-model="ruleForm.currency"
                filterable
                clearable
                placeholder="请选择币种"
                size="small"
                style="width:100%;"
              >
                <el-option
                  v-for="(item,index) in options2"
                  :key="index"
                  :label="item.name"
                  :value="item.shortname"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input style="width:100%;margin-left:0" type="textarea" v-model="ruleForm.remark"></el-input>
            </el-form-item>
            <el-form-item label="银行账户" prop="settleAccountId">
              <el-select v-model="ruleForm.settleAccountId" filterable  clearable placeholder="请选择银行账户" size="small" style="width:100%;">
                <el-option
                  v-for="(item,index) in options"
                  :key="index"
                  :label="item.abbr+'\n'+item.account"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实际打款日" prop="realityPayTime">
              <el-date-picker
                  v-model="ruleForm.realityPayTime"
                  style="width:100%;"
                  type="date"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="实际金额" prop="money">
              <el-input v-model="ruleForm.money" placeholder="选填" style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item label="水单上传" prop="deliveryImg" >
          <el-upload
                style="text-align:left"
                class="upload-demo"
                :action="uploadAction"
                :headers="uploadHeaders"
                :on-success="businessSuccess"
                :on-remove="businessRemove"
                :before-upload="beforeUpload"
                list-type="picture"
                :limit="1"
                name="upload"
                ref="uploadDeliveryImgRef"
              >
                <el-button size="small" type="primary">
                  上传水单
                </el-button>
          </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" :loading="submitting" @click="submitPayment('ruleForm')">提交</el-button>
        </div>
      </el-dialog>
      <el-dialog
        class="abnormal"
        title="唛头下载"
        :visible.sync="dialogFormVisible3"
        :close-on-click-modal="true"
        :modal-append-to-body="false"
        :destroy-on-close="true"
        width="35%"
      >
        <div class="dialog-footer" style="text-align:center;">
          <el-select v-model="marks" clearable placeholder="请选择唛头模板" value-key="id">
            <el-option
              v-for="(item,index) in options3"
              :key="index"
              :label="item.marks"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="success" @click="getBatchMaitou()">单张唛头</el-button>
          <el-button type="info" @click="getBatchMaitou('a4')">A4纸唛头</el-button>
          <!-- <el-button type="info" @click="getMaitou2('a4s')">A4纸唛头(无代码)</el-button> -->
        </div>
      </el-dialog>
    </el-card>

    <!-- 物流抽屉 -->
    <el-drawer title="最新物流状态" :visible.sync="drawer" :with-header="false" >
      <div class="drawer-box">
        <p>订单物流进度</p>
        <el-timeline style="overflow-y: auto;height: 600px;float: left;padding:1px;" >
            <el-timeline-item
              v-for="(item, index) in schedule"
              :key="index"
              :icon="item.icon"
              :size="item.size"
              :type="item.type"
              :color="index === 0 ? '#ff0000' : ''"
            >
              <b>{{item.content}}</b>
              <span style="margin-left:15px">{{item.createTime|dateformat}}</span>
            </el-timeline-item>
          </el-timeline>
      </div>
    </el-drawer>

    <el-drawer title="派送信息" :visible.sync="drawerTrack" :with-header="false" >
      <div class="drawer-box">
        <p>订单派送状态</p>
        <div v-if="!trackData || trackData.length === 0" style="padding: 12px 0;">
          <p>暂无派送轨迹</p>
          <el-button v-if="aftershipUrl" type="primary" size="small" @click="openAftership">去 AfterShip 查看</el-button>
        </div>
        <el-timeline v-else style="overflow-y: auto;height: 600px;float: left;padding:1px;" >
            <el-timeline-item
              v-for="(item, index) in trackData"
              :key="index"
              :icon="item.icon"
              :size="item.size"
              :type="item.type"
              :color="index === 0 ? '#ff0000' : ''"
            >
              <b>{{item.tracking_detail}}</b>
              <span style="margin-left:15px">{{item.checkpoint_date}}</span>
            </el-timeline-item>
          </el-timeline>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";
//引入组件
import Country from "@/components/Country";
export default {
  components: {
    Country,
  },
  data() {
    const checkCurrency = (rule, value, callback) => {
      if (!this.ruleForm.currency) {
        return callback(new Error("请选择折合币种"));
      }
      callback();
    };
    return {
      loading: false,
      submitting: false,
      searchExpanded: false,
      showExtraColumns: false,
      uploadHeaders: { token: sessionStorage.getItem("token") || "" },
      radio: "",
      fileVal: "",
      fileType: [
        { label: "0110退税", value: "1" },
        { label: "FBA标签", value: "2" },
        { label: "报价文件", value: "3" },

        { label: "箱单发票", value: "5" },
        { label: "POA", value: "6" },
        { label: "税号证明", value: "7" },
        { label: "报关单", value: "8" },
        { label: "保险单", value: "9" },
        { label: "认证资料", value: "10" },
        { label: "过磅单", value: "13" },

        { label: "收款水单", value: "18" },
        { label: "产品图", value: "25" },
 
        { label: "保函", value: "27" }
      ],
      dialogTableVisible: false,
      options: [],
      options2: [],
      options3: [],
      settleAccountId: "",
      orderClientNo: "",
      dialogFormVisible3: false,
      templateSelection: "", //订单号
      country: "", //国家
      // orderVal: "", //订单号
      orderData: [], //订单列表
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      marks: {},
      statusData: [
        {
          value: 0,
          label: "未支付",
        },
        {
          value: 1,
          label: "已支付",
        },
      ],
      ruleForm: {
        money: "",
        remark: "",
        settleAccountId: "",
        currency: "",
        realityPayTime:null,
        sellerName:"",
        deliveryImg: ""
      },
      rules: {
        money: [{ required: false, message: "此项不能为空", trigger: "blur" }],
        settleAccountId: [{ required: true, message: "此项不能为空", trigger: "change" }],
        currency: [{ required: true, validator: checkCurrency, trigger: "change" }]
      },
      paymentStatus: "", //支付状态
      createTime: [], //下单时间
      orderNo: "",
      orderNos:"",
      orderNoList: [],
      clientNo: "",
      drawerTrack: false,
      trackData: [],
      aftershipUrl: "",
      shipmentId: "",
      shipmentIdList:"",
      goodsName: "",
      mtDownType: true,
      whStatus: "",
      whStatusList: [],
      num: 1,
      quanbu: "0",
      dairuku: "0",
      yirucang: "0",
      yikaichuan: "0",
      yidaogang: "0",
      yitigui: "0",
      yipaisong: "0",
      yiquxiao: "0",
      orderLogStatus: "", //物流状态
      orderStatusList: "0,1,2",
      drawer: false,
      schedule: [],
    };
  },
  computed: {
    uploadAction() {
      return this.mApi + "file/upload";
    }
  },
  methods: {
    enrichOrderRow(row) {
      const item = { ...row };
      if (item.enLogno != null && item.enLogno !== "") {
        item.enLogno = String(item.enLogno).split("\n").filter(Boolean);
      } else {
        item.enLogno = [];
      }
      if (item.realKg == 0) {
        item.realKg = "_";
      }
      if (item.finalsettle == 0) {
        item.finalsettle = "_";
      }
      if (item.shipmentType == "1") {
        item.shipment = `${item.shipmentCountry || ""} / ${item.shipmentZip || ""}`.replace(/^ \/ | \/ $/g, "") || "私人地址";
      } else {
        item.shipment = `${item.shipmentCode || ""} / ${item.shipmentZip || ""}`.replace(/^ \/ | \/ $/g, "");
      }
      if (item.realCtn == 0) {
        item.pvwText = `${item.ctn} / ${item.kg} / ${item.cbm}`;
      } else {
        item.pvwText = `${item.realCtn} / ${item.realKg} / ${item.realCbm}`;
      }
      item.pvw = item.pvwText;
      if (item.finalsettle == 0 || item.finalsettle == "_") {
        item.settleText = "—";
      } else {
        item.settleText = `${item.finalsettle}${item.settleType == "0" || item.settleType == 0 ? " KG" : " CBM"}`;
      }
      if (!item.clearanceModeTxt && (item.clearanceMode === "0" || item.clearanceMode === "1")) {
        item.clearanceModeTxt = item.clearanceMode === "1" ? "单票单清" : "合单清";
      }
      if (item.recStatus == "0") {
        item.recStatusText = "未付款";
      } else if (item.recStatus == "1") {
        item.recStatusText = "已付款";
      } else {
        item.recStatusText = "";
      }
      return item;
    },
    declareTagType(row) {
      const code = String((row && row.declareType) || "");
      const txt = (row && row.declareTypeTxt) || "";
      if (code === "1" || txt.indexOf("0110") >= 0 || txt.indexOf("退税") >= 0) return "warning";
      if (["8", "9", "10", "11"].indexOf(code) >= 0) return "success";
      if (code === "3" || code === "4") return "";
      return "info";
    },
    handleSearch() {
      this.currentPage = 1;
      this.orderLists();
      this.orderListsCount();
    },
    openAftership() {
      if (this.aftershipUrl) {
        window.open(this.aftershipUrl, "_blank");
      }
    },
    //打开物流抽屉
    openDrawerTrack(index, row) {
      this.trackData = [];
      this.aftershipUrl = "";
      const trackingNumber = row;
      httpApi
        .getTracking({
          params: { numbers: trackingNumber }
        })
        .then(res => {
          if (res.data.code === "ok") {
            const data = res.data.data;
            if (Array.isArray(data)) {
              this.trackData = data;
            } else if (data && typeof data === "object") {
              this.trackData = Array.isArray(data.trackinfo) ? data.trackinfo : [];
              this.aftershipUrl = data.aftershipUrl || "";
            } else {
              this.trackData = [];
            }
            if (!this.aftershipUrl && trackingNumber) {
              this.aftershipUrl =
                "https://www.aftership.com/track?t=" +
                encodeURIComponent(String(trackingNumber).replace(/\s/g, ""));
            }
            this.drawerTrack = true;
          } else {
            this.$message.error(res.data.message || "获取派送信息失败");
          }
        })
        .catch(error => {
          console.error("获取派送信息异常:", error);
          this.$message.error("获取派送信息失败，请稍后重试");
        });
    },
    setFile(response) {
      if (!response || response.code !== "ok" || !response.data) {
        this.$message.error((response && response.message) || "上传失败");
        return;
      }
      const arr = response.data;
      httpApi
        .addFile({
          ext: arr.ext,
          name: arr.filename,
          orderNo: this.orderNoList[0],
          size: arr.size,
          type: this.fileVal,
          url: arr.url
        })
        .then(res => {
          if (res.data.code === "ok") {
            this.$message.success("上传成功");
            this.orderLists();
            this.fileVal = "";
          } else {
            this.$message.error(res.data.message || "关联订单文件失败");
          }
        })
        .catch(error => {
          console.error("关联订单文件异常:", error);
          this.$message.error("关联订单文件失败，请稍后重试");
        });
    },
    beforeOrderFileUpload() {
      this.uploadHeaders = { token: sessionStorage.getItem("token") || "" };
      if (this.orderNoList.length !== 1) {
        this.$message.warning("请选择一条订单");
        return false;
      }
      if (!this.fileVal) {
        this.$message.warning("请选择文件类型");
        return false;
      }
      return true;
    },
    change: function (index) {
      let that = this;
      this.currentPage = 1;
      this.num = index;
      if (this.num === 1) {
        that.orderLogStatus = "";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 3) {
        that.orderLogStatus = "1,2";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 4) {
        that.orderLogStatus = "3,4,5,6";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 5) {
        that.orderLogStatus = "7,15";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 6) {
        that.orderLogStatus = "8,9,10,11";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 7) {
        that.orderLogStatus = "12,16";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 8) {
        that.orderLogStatus = "13,14";
        that.orderStatusList = "0,1,2";
        that.orderLists();
      } else if (this.num === 9) {
        that.orderLogStatus = "";
        that.orderStatusList = "3";
        that.orderLists();
      }
    },
    //点击订单号跳往详情
    toOrderdeta(orderNo) {
      this.$router.push("/orderdetails/" + orderNo);
    },
    updadate(orderNo){
      this.$router.push({path:"/update/",query:{
      orderNo:orderNo
      }});
    },
    //点击行选中
    handleRowClick(row, column, event){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //选择
    handleSelectionChange(val) {
      this.orderNoList = val.map(i => i.orderNo);
      this.whStatusList = val.map(i => i.whStatus);
    },
    init(){
      let that=this
      httpApi
      .listParams({params:{
        type:"sys_bank_type",
        enable:"1"
      }})
      .then(res => {
        if (res.data.code == "ok") {
          that.options = res.data.data;
        }
      });
    },
    init2() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_currency",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options2 = res.data.data;
          }
        });
    },
    init3() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_marks",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options3 = res.data.data;
          }
        });
    },
    //移除签收证明图片
    businessRemove() {
      this.ruleForm.deliveryImg = ""
      this.$refs.uploadDeliveryImgRef.clearFiles(); //清空上传单列表
    },
    businessSuccess(response) {
      if (response && response.code === "ok" && response.data) {
        this.ruleForm.deliveryImg = response.data.url;
      } else {
        this.$message.error((response && response.message) || "上传失败");
      }
    },
    beforeUpload(file){//
        this.uploadHeaders = { token: sessionStorage.getItem("token") || "" };
        let isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/bmp';
        let isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
            this.$message.error('只能上传jpeg、jpg、png、bmp格式的图片');
        }
        if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },
    //复制下单
    copyOrder() {
      if(this.orderNoList.length == 1){
        this.orderNo = this.orderNoList[0];
        if (this.orderNo) {
          this.$router.push({
            path: "/orderby2",
            query: { orderNo: this.orderNo },
          });
        } else {
          this.$message.warning("请选择订单");
        }
      }else{
        this.$message.warning("请选择一条订单！")
      }
    },
    quxiaodingdan() {
      if (this.orderNoList.length !== 1) {
        this.$message.warning("请选择一条订单");
        return;
      }
      const orderNo = this.orderNoList[0];
      this.$confirm("确定要取消该订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => httpApi.cancel({ orderNo }))
        .then(res => {
          if (res.data.code === "ok") {
            this.$message.success("订单取消成功");
            this.orderLists();
            this.orderListsCount();
          } else {
            this.$message.error(res.data.message || "取消失败");
          }
        })
        .catch(action => {
          if (action !== "cancel") {
            console.error("取消订单异常:", action);
          }
        });
    },
    //下载唛头
    getMaitou() {
       if (!this.orderNoList || this.orderNoList.length === 0) {
        this.$message.warning('请至少选择一条订单记录');
        return;
        }
        this.dialogFormVisible3 = true;
        this.init3();

      // if(this.orderNoList.length === 1){
      //   this.templateSelection = this.orderNoList[0];
      //   if (this.templateSelection) {
      //     this.dialogFormVisible3 = true;
      //     this.init3();
      //   } else {
      //     this.$message.error("请选择订单");
      //   }
      // }else{
      //   this.$message.warning("请选择一条订单！")
      // }
    },
    //下载唛头
    getMaitou2(type) {
      this.dialogFormVisible3 = false;
      let typeFlag = type ? type : "";
      window.open(
        this.mApi +
              "report/mai_tou3?orderNo=" + this.templateSelection + "&type=" + typeFlag + "&marksModel=" + this.marks.marksModel +"&suffix="+this.marks.suffix+"&serialNum="+this.marks.serialNum+"&isHasSuffix="+this.marks.isHasSuffix
      );
    },

    //批量下载唛头
    getBatchMaitou(type) {
      if (!this.marks.marksModel) {
      this.$message.warning('请先选择唛头模板');
      return;
      } 

      let that = this;
      let typeFlag = type ? type : "";
      if (!that.orderNoList || that.orderNoList.length === 0) {
        that.$message.warning('请至少选择一条订单记录');
        that.dialogFormVisible3 = false;
        return;
      }

       const loading = this.$loading({
          lock: true,
          text: '正在生成唛头文件...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      httpApi
        .mtBDown({
          orderNoList: that.orderNoList,
          marksModel: that.marks.marksModel,
          suffix: that.marks.suffix,
          serialNum: that.marks.serialNum,
          isHasSuffix: that.marks.isHasSuffix,
          type: typeFlag
        })
    .then(res => {
          loading.close();
          if (!res.data || res.data.byteLength === 0) {
            that.$message.error('生成的文件为空，请检查数据');
            return;
          }
          const blob=new Blob([res.data],{ type: 'application/zip' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `批量唛头下载_${new Date().toLocaleDateString()}.zip`;
          document.body.appendChild(link);
          link.click();
             // 清理
          setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
          }, 100);
           that.dialogFormVisible3 = false;  // 关闭弹窗
          }).catch(error => {
            loading.close();
            console.error('下载失败:', error);
            that.$message.error(`下载失败: ${error.response?.data?.message || error.message || '未知错误'}`);
          }).finally(() => {
            loading.close();
          });
    },

    //下载入仓单
    getRucangdan() {
      if(this.orderNoList.length === 1){
        this.templateSelection = this.orderNoList[0];
        if (this.templateSelection) {
          window.open(
            this.mApi + "report/ru_cang_dan?orderNo=" + this.templateSelection
          );
        } else {
          this.$message.error("请选择订单");
        }
      }else{
        this.$message.warning("请选择一条订单！")
      }
    },
    getBill(e) {
      window.open(this.mApi + "report/bill?orderNos=" + e);
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.currentPage = 1;
      //每页下拉显示数据
      this.orderLists();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      //点击第几页
      this.orderLists();
    },
    // 国家选择
    getCountry(e) {
      this.country = e;
    },
    orderLists() {
      let getTime = "";
      let setTime = "";
      this.radio = "";
      this.orderNo = "";
      if (this.createTime && this.createTime.length !== 0) {
        getTime = Math.floor(new Date(this.createTime[0]).getTime() / 1000);
        setTime = Math.floor(new Date(this.createTime[1]).getTime() / 1000);
      }
      this.loading = true;
      httpApi
        .orderList({
          params: {
            page: this.currentPage,
            rows: this.pagesize,
            createStartTime: getTime || undefined,
            createEndTime: setTime || undefined,
            clientNos: this.orderClientNo || undefined,
            country: this.country || undefined,
            recStatus: this.paymentStatus !== "" ? this.paymentStatus : undefined,
            orderNos: this.orderNos || undefined,
            shipmentIds: this.shipmentIdList || undefined,
            goodsName: this.goodsName || undefined,
            orderLogStatusList: this.orderLogStatus || undefined,
            orderStatusList: this.orderStatusList
          }
        })
        .then(res => {
          if (res.data.code === "ok") {
            const pageData = res.data.data || {};
            this.orderData = (pageData.rows || []).map(row => this.enrichOrderRow(row));
            this.total = pageData.total || 0;
          } else {
            this.$message.error(res.data.message || "获取订单列表失败");
          }
        })
        .catch(error => {
          console.error("查询订单异常:", error);
          this.$message.error("获取订单列表失败，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitDialog() {
      if (this.orderNoList.length > 0) {
        this.init();
        this.init2();
        this.dialogTableVisible = true;
      } else {
        this.$message.warning("请至少选择一条订单");
      }
    },
    closeDialog() {
      this.dialogTableVisible = false;
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate();
      }
    },
    submitPayment(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return false;
        }
        const realityPayTime = this.ruleForm.realityPayTime
          ? Math.floor(new Date(this.ruleForm.realityPayTime).getTime() / 1000)
          : undefined;
        this.submitting = true;
        httpApi
          .submitPayment({
            orderNoList: this.orderNoList,
            realMoney: this.ruleForm.money || undefined,
            remark: this.ruleForm.remark,
            settleAccountId: this.ruleForm.settleAccountId,
            toCurrency: this.ruleForm.currency,
            realityPayTime,
            picUrl: this.ruleForm.deliveryImg
          })
          .then(res => {
            if (res.data.code === "ok") {
              this.closeDialog();
              this.$refs.ruleForm.resetFields();
              this.ruleForm.deliveryImg = "";
              this.$message.success(res.data.data || "提交成功");
              this.orderLists();
            } else {
              this.$message.error(res.data.message || "提交失败");
            }
          })
          .catch(error => {
            console.error("提交付款异常:", error);
            this.$message.error("提交失败，请稍后重试");
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
    //查询状态数字
    orderListsCount() {
      let that = this;

      const arr = [
        {
          orderLogStatusList: "",
          orderStatusList: "0,1,2",
          s: "quanbu",
        },
        {
          orderLogStatusList: "1,2",
          orderStatusList: "0,1,2",
          s: "dairuku",
        },
        {
          orderLogStatusList: "3,4,5,6",
          orderStatusList: "0,1,2",
          s: "yirucang",
        },
        {
          orderLogStatusList: "7,15",
          orderStatusList: "0,1,2",
          s: "yikaichuan",
        },
        {
          orderLogStatusList: "8,9,10,11",
          orderStatusList: "0,1,2",
          s: "yidaogang",
        },
        {
          orderLogStatusList: "12,16",
          orderStatusList: "0,1,2",
          s: "yitigui",
        },
        {
          orderLogStatusList: "13,14",
          orderStatusList: "0,1,2",
          s: "yipaisong",
        },
        {
          orderLogStatusList: "",
          orderStatusList: "3",
          s: "yiquxiao",
        },
      ];

      for (var i = 0; i < arr.length; i++) {
        var obj = arr[i];
        httpApi
          .orderListCount({
            params: {
              orderLogStatusList: obj.orderLogStatusList, //订单物流状态
              orderStatusList: obj.orderStatusList,
              s: obj.s,
            },
          })
          .then((res) => {
            if (res.data.code == "ok") {
              const s = res.config.params.s;
              if (s === "quanbu") {
                that.quanbu = res.data.data;
              }
              if (s == "dairuku") {
                that.dairuku = res.data.data;
              }
              if (s == "yirucang") {
                that.yirucang = res.data.data;
              }
              if (s == "yikaichuan") {
                that.yikaichuan = res.data.data;
              }
              if (s == "yidaogang") {
                that.yidaogang = res.data.data;
              }
              if (s == "yitigui") {
                that.yitigui = res.data.data;
              }
              if (s == "yipaisong") {
                that.yipaisong = res.data.data;
              }
              if (s == "yiquxiao") {
                that.yiquxiao = res.data.data;
              }
            } else {
              that.$message.error(res.data.message);
            }
          });
      }
    },
    openDrawer(index, row) {
      this.schedule = [];
      httpApi
        .findOrder({
          params: { orderNo: row.orderNo }
        })
        .then(res => {
          if (res.data.code === "ok") {
            const list = (res.data.data && res.data.data.findOrderLogisticsResponseList) || [];
            this.schedule = list;
            this.drawer = true;
          } else {
            this.$message.error(res.data.message || "获取物流信息失败");
          }
        })
        .catch(error => {
          console.error("获取物流信息异常:", error);
          this.$message.error("获取物流信息失败，请稍后重试");
        });
    },
  },
  created() {
    this.orderLists();
    this.init();
    this.init2();
    this.orderListsCount();
  },
  watch: {
    createTime(newVal) {
      if (newVal == null) {
        this.createTime = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>

//tab
.current {
  color: #6397f1;
  background-color: #fff;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
  // border-top: 1px solid #ccc!important;
}
.table_tag{
  padding: 0px;
}

.table_tag .el-col div {
  white-space: nowrap; /* 禁止换行 */
}

.el-row {
  background: #ebeef5;
  color: #909399;
  // border-top: 1px solid #ccc;
  // border-bottom: 1px solid #ccc;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.grid-content {
  font-size: 14px;
  min-height: 40px;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border: 1px solid transparent;
  margin-top: -1px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.search-panel {
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px 12px 10px;

  &__main {
    display: grid;
    grid-template-columns: 200px 200px 200px 140px auto;
    gap: 10px 12px;
    align-items: end;
  }

  &__extra {
    display: grid;
    grid-template-columns: 140px 360px 140px;
    gap: 10px 12px;
    align-items: end;
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed #dcdfe6;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 4px;
    padding-bottom: 1px;
    white-space: nowrap;
  }

  &__toggle {
    color: #909399;
    padding-left: 6px;
    padding-right: 6px;
    &:hover {
      color: #409eff;
    }
  }
}

.search-field {
  display: flex;
  flex-direction: column;
  min-width: 0;

  &__label {
    font-size: 12px;
    color: #606266;
    line-height: 1;
    margin-bottom: 6px;
  }

  &--w200 {
    width: 200px;
  }

  &--w140 {
    width: 140px;
  }

  &--flex {
    min-width: 0;
  }

  &--date {
    width: 360px;
  }

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor,
  /deep/ .el-textarea {
    width: 100%;
  }

  /deep/ .el-textarea__inner {
    resize: vertical;
    min-height: 52px !important;
    padding: 5px 8px;
    line-height: 1.4;
  }
}

.search-expand-enter-active,
.search-expand-leave-active {
  transition: opacity 0.2s ease, max-height 0.2s ease;
  overflow: hidden;
  max-height: 120px;
}

.search-expand-enter,
.search-expand-leave-to {
  opacity: 0;
  max-height: 0;
}

@media (max-width: 1280px) {
  .search-panel__main {
    grid-template-columns: 200px 200px 200px 140px;
    .search-panel__actions {
      grid-column: 1 / -1;
      justify-content: flex-end;
      padding-top: 4px;
    }
  }
  .search-panel__extra {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    .search-field--date {
      width: 100%;
      grid-column: 1 / -1;
    }
  }
}

.toolbar {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .toolbar-line {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
  }

  .toolbar-line--actions {
    flex-wrap: wrap;
    padding-top: 2px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    .action-file-type {
      width: 120px;
      flex-shrink: 0;
    }
    .upload-inline {
      display: inline-flex;
      flex-shrink: 0;
    }
    /deep/ .el-button + .el-button {
      margin-left: 0;
    }
  }

  .extra-cols-toggle {
    margin-left: 8px;
    color: #606266;
  }
}

.table_tag {
  margin-top: 14px;
  margin-bottom: 8px;
}

.cell-sub {
  color: #909399;
  font-size: 12px;
  line-height: 1.3;
  margin-top: 2px;
}

.channel-cell {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 6px;
  line-height: 1.3;

  &__name {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.clearance-tag {
  margin-left: 0;
  flex-shrink: 0;
}

.table-wrap {
  width: 100%;
  overflow-x: auto;
}

.myorder-table {
  width: 100% !important;
}

.empty-tip {
  color: #909399;
  font-size: 14px;
}

::v-deep .el-card__body {
  padding: 0px !important;
}

/deep/.el-radio__label {
  display: none;
}
/deep/.block {
  margin-top: 20px;
  text-align: center;
}
/deep/ .el-drawer:focus {
  outline: none;
}
.drawer-box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 30px;
  p:first-child{
    font-size: 20px;
    margin-bottom: 20px;
  }
  p:last-child{
    font-size: 16px;
    color: red;
  }
}
</style>